export default "__VITE_ASSET__CsB8ubV1__"